import React from "react";
import TableContainer from "./TableContainer";
import { Stack, Typography } from "@mui/material";
import "./management-table.css";

//Import Breadcrumb
const EMPTY_ROWS = [];
const EMPTY_COLUMNS = [];

const Table = ({ header, data, getLengthPage, totalPage, noPagination, noShowLength, length, page, sort, setSorted, sort_by, setSortBy, showEmptyHeader = false, emptyMessage = "No record", manualPagination = false, onRowClick }) => {
  return (
    <React.Fragment>
      {
        data?.length > 0 || showEmptyHeader ?
          <TableContainer
            columns={header || EMPTY_COLUMNS}
            data={data || EMPTY_ROWS}
            isPagination={true}
            getLengthPage={getLengthPage}
            length={length}
            iscustomPageSize={false}
            customPageSize={10}
            page={page}
            totalPage={totalPage}
            noPagination={noPagination}
            noShowLength={noShowLength}
            sort={sort}
            setSorted={setSorted}
            sort_by={sort_by}
            setSortBy={setSortBy}
            emptyMessage={emptyMessage}
            manualPagination={manualPagination}
            onRowClick={onRowClick}
          />
          :
          <Stack justifySelf={""} pl={2}>
            <Typography>
              No record
            </Typography>
          </Stack>

      }

    </React.Fragment>
  );
};

export default Table;
